import React, { Component } from 'react';
import PropTypes from 'prop-types';
import config from 'config/config';
import { findDOMNode } from 'react-dom';
import Modal from 'utils/components/modal';
import ClickToCopy from 'app/scripts/components/features/click-to-copy';
import { closest } from 'utils/dom';
import SocialReviewsModal from '../modals/social-reviews';
import SelectInput from '../common/inputs/select-input';

var CodeTypeKeys = {
  UNIVERSAL: { value: 'universal', text: 'Universal Code' }
};

class SocialReviews extends Component {
  constructor(props) {
    super(props);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.state = {
      platform: CodeTypeKeys.UNIVERSAL
    };
  }
  handleCodeTypeChange(platform) {
    this.setState({ platform });
  }

  toast(component) {
    var domNode = findDOMNode(component);
    var toastNode = domNode.parentNode.parentNode.querySelector('.toast');
    toastNode.className = 'toast animate';
    setTimeout(() => (toastNode.className = 'toast'), 3000);
  }

  getSpotCode(spotId) {
    var launcher = config.api.newLauncher;
    var html1 = `<span class="color4">&lt;script</span> <span class="color2">async</span> <span class="color2">src</span>=<span class="color3">"${launcher}"</span> 
      <span class="color2">data-social-reviews</span>=<span class="color3">"true"</span>
      <span class="color2">data-spotim-module</span>=<span class="color3">"spotim-launcher"</span>
      <span class="color2">data-post-url</span>=<span class="color3">"POST_URL"</span>
      <span class="color2">data-post-id</span>=<span class="color3">"POST ID GOES HERE"</span>
      <span class="color4">&gt;</span>
      <span class="color4">&lt;/script&gt;</span>`;
    html1 = html1.replace('{{SPOT_ID}}', spotId);
    var coloredCode = '<div>' + html1 + '</div>';
    var code = `<script async src="${launcher}" data-social-reviews="true" data-spotim-module="spotim-launcher" data-post-url="POST_URL" data-post-id="POST ID GOES HERE"></script>`;
    code = code.replace('{{SPOT_ID}}', spotId);
    return {
      html: coloredCode,
      code
    };
  }
  getConversationConfigCode() {
    var coloredCode =
      '<span class="color4">&lt;div</span> <span class="color2">data-social-reviews</span>=<span class="color3">"true"</span> <span class="color2">class</span>=<span class="color3">"spot-im-frame-inpage"</span> <span class="color2">data-post-id</span>=<span class="color3">"POST_ID_GOES_HERE"</span>&gt;<span class="color4">&lt;/div&gt;</span>';
    var code =
      '<div class="spot-im-frame-inpage" data-social-reviews=true data-post-id="POST_ID_GOES_HERE"></div>';
    return { html: coloredCode, code };
  }
  getSpotIdCode() {
    var coloredCode = `<span class="color3">${this.props.spotId}</span>`;
    var code = this.props.spotId;
    return { html: coloredCode, code };
  }
  reviewsWidget() {
    var spotId = this.props.spotId;
    var url = config.api.starsRating;
    var coloredCode = `<span class="color4">
                            &lt;div</span> <span class="color2">class</span>=<span class="color3">"spot-im-stars-rating-module"</span> <span class="color2">data-post-id</span>=<span class="color3">"POST ID HERE"</span> <span class="color2">data-spot-id</span>=<span class="color3">"${spotId}"</span>&gt;<span class="color4">&lt;/div&gt;</span><span class="color4">&lt;script</span>
                            <span class="color2">type</span>=<span class="color3">"text/javascript"</span> <span class="color2">src</span>=<span class="color3">"${url}"</span>&gt;<span class="color4">&lt;/script&gt;</span>`;

    var code = `<div class="spot-im-stars-rating-module" data-post-id="POST ID HERE" data-spot-id="${spotId}"></div><script type="text/javascript" src="${url}"></script>`;

    return { html: coloredCode, code };
  }

  renderCode(data) {
    return (
      <div className="code-wrap">
        <span className="toast">Copied to clipboard </span>
        <div className="code">
          <ClickToCopy content={data.code} onCopy={this.toast} />
          <div className="gutter">
            <div className="line-numbers">
              1<br />2<br />3<br />4<br />5<br />6<br />7<br />8<br />9<br />
              10
              <br />
              11
              <br />
              12
              <br />
              13
              <br />
              14
              <br />
              15
              <br />
              16
              <br />
              17
              <br />
              18
              <br />
              19
              <br />
              20
              <br />
              21
              <br />
              22
              <br />
              23
              <br />
              24
              <br />
              25
              <br />
              26
              <br />
              27
              <br />
              28
              <br />
              29
              <br />
              30
            </div>
          </div>
          <div className="content" dangerouslySetInnerHTML={{ __html: data.html }} />
        </div>
      </div>
    );
  }
  renderUniversalCode() {
    return (
      <div className="code-section" key="1">
        <div className="code-wrapper">
          <div className="code-title">Code for Your Site</div>
          <div>
            <div className="code-item">
              Place this code where you’d like the Social Reviews to display on your pages.
            </div>
            {this.renderCode(this.getSpotCode(this.props.spotId))}
            <div className="code-item">
              In order to show a specific conversation, use a unique ID for each page. You may
              replace <span className="head-tag">&nbsp;"POST_ID_GOES_HERE"&nbsp;</span> with your
              own ID.
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderWordPress() {
    return (
      <div className="code-section">
        <div className="code-wrapper">
          <div className="code-title">Wordpress Setup Instructions</div>
          <div>
            <div className="code-item">
              1. In your WordPress admin dashboard, select <strong>Plugins &gt; Add New </strong>{' '}
              from the left-hand navigation pane.
            </div>
            <div className="code-item">
              2. Type "Spot.IM Comments" in the search field, and select the plugin of that same
              name.
            </div>
            <div className="code-item">
              3. On the plugin page, click <strong> Install Now</strong>, located in the lower
              right-hand corner. You will be brought to the installation page.
            </div>
            <div className="code-item">
              4. On the installation page, click <strong>Activate Plugin</strong>.
            </div>
            <div className="code-item">
              5. Copy the unique Spot ID below and paste it in your Spot.IM Settings page, located
              in your WordPress dashboard <strong>(Settings &gt; Spot.IM Settings).</strong>
            </div>
            {this.renderCode(this.getSpotIdCode())}
          </div>
        </div>
      </div>
    );
  }
  renderUniversal() {
    return this.renderUniversalCode();
  }
  openModal() {
    this.refs.socialReviewsModal.show();
  }
  closeModal() {
    this.refs.socialReviewsModal.hide();
  }
  render() {
    return (
      <div className="setup-instructions">
        <div className="main-content">
          <div className="platform-selection">
            <SelectInput
              title="Setup Social Reviews"
              onChange={this.handleCodeTypeChange.bind(this)}
              description="Choose your site platform"
              options={[CodeTypeKeys.UNIVERSAL]}
              value={CodeTypeKeys.UNIVERSAL}
            />
          </div>
          {this.renderUniversal()}
        </div>
        <Modal ref="socialReviewsModal" className="modal-social-reviews">
          <SocialReviewsModal onClose={this.closeModal} />
        </Modal>
      </div>
    );
  }
}

SocialReviews.propTypes = {
  spotId: PropTypes.string.isRequired
};

SocialReviews.displayName = 'SocialReviews';

export default SocialReviews;
